import {domReady} from '@roots/sage/client';
import Splide from '@splidejs/splide';
import Alpine from 'alpinejs';
import initPlausibleThomannClick from '@scripts/plausible-thomann-click';

// Delegated on document, so it does not have to wait for domReady and covers
// links that Alpine or Splide reveal later.
initPlausibleThomannClick();

/**
 * app.main
 */
const main = async (err) => {
    if (err) {
        // handle hmr errors
        console.error(err);
    }

    // application code
    window.Alpine = Alpine;
    Alpine.start();
    let elms = document.getElementsByClassName('splide');

    for (let i = 0; i < elms.length; i++) {
        new Splide(elms[i]).mount();
    }

    // code for handling thumbnail carousel
    const sliderEl = document.getElementById('thumbnail-slider')
    if (sliderEl) {
        let splide = new Splide(sliderEl);
        let thumbnails = document.getElementsByClassName('thumbnail');
        let current;

        if (splide && thumbnails) {
            for (let i = 0; i < thumbnails.length; i++) {
                initThumbnail(thumbnails[i], i);
            }

            function initThumbnail(thumbnail, index) {
                thumbnail.addEventListener('click', function () {
                    splide.go(index);
                });
            }

            splide.on('mounted move', function () {
                let thumbnail = thumbnails[splide.index];

                if (thumbnail) {
                    if (current) {
                        current.classList.remove('is-active');
                    }

                    thumbnail.classList.add('is-active');
                    current = thumbnail;
                }
            });

            splide.mount();
        }
    }
};

/**
 * Initialize
 *
 * @see https://webpack.js.org/api/hot-module-replacement
 */
domReady(main);
import.meta.webpackHot?.accept(main);
